import {
  DATASTRATEGY,
  IEntity,
  STORAGESTRATEGY,
} from '@proximus/entity-manager';
import { LocalForageStrategy } from '@proximus/entity-manager/lib/storage/strategies/local-forage.strategy';

const MailboxEntity: IEntity<any> = {
  rel: 'mbx:mailbox',
  url: '/rest/mailbox/mailbox{?cdbId,appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'encryptionKey',
    'customHeaders',
  ],
  version: 'v1',
  timeout: 10000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: LocalForageStrategy.ID,
  customHeaders: {
    'Content-Type': 'application/json',
  },
};

const PasswordRecoveryEntity: IEntity<any> = {
  rel: 'mbx:recoveryMethods',
  url: '/rest/mailbox/mailbox/{mbxId}/recovery/management{?appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'encryptionKey',
  ],
  version: 'v1',
  timeout: 10000,
  dataStrategy: DATASTRATEGY.NONE,
  storageStrategy: STORAGESTRATEGY.NONE,
};

const PasswordRecoveryEmailEntity: IEntity<any> = {
  rel: 'mbx:sendTokenToAddEmailRecoveryMethod',
  url: '/rest/mailbox/mailbox/{mbxId}/recovery/management/mail/{mail}{?appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'encryptionKey',
  ],
  version: 'v1',
  timeout: 10000,
  dataStrategy: DATASTRATEGY.NONE,
  storageStrategy: STORAGESTRATEGY.NONE,
};

const PasswordRecoverySmsEntity: IEntity<any> = {
  rel: 'mbx:sendTokenToAddSmsRecoveryMethod',
  url: '/rest/mailbox/mailbox/{mbxId}/recovery/management/sms/{mobileNbr}{?appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'encryptionKey',
  ],
  version: 'v1',
  timeout: 10000,
  dataStrategy: DATASTRATEGY.NONE,
  storageStrategy: STORAGESTRATEGY.NONE,
};

const PasswordRecoveryActivateSmsEntity: IEntity<any> = {
  rel: 'mbx:addSmsRecoveryMethod',
  url: '/rest/mailbox/mailbox/{mbxId}/recovery/management/sms/token/{token}{?appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'encryptionKey',
  ],
  version: 'v1',
  timeout: 10000,
  dataStrategy: DATASTRATEGY.NONE,
  storageStrategy: STORAGESTRATEGY.NONE,
};

const PasswordEntity: IEntity<any> = {
  rel: 'mbx:password',
  url: '/rest/mailbox/mailbox/{mbxId}/password{?appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'encryptionKey',
    'customHeaders',
  ],
  version: 'v1',
  timeout: 10000,
  dataStrategy: DATASTRATEGY.NONE,
  storageStrategy: STORAGESTRATEGY.NONE,
  customHeaders: {
    'Content-Type': 'application/json',
  },
};

const CheckAliasEntity: IEntity<any> = {
  rel: 'mbx:checkAlias',
  url: '/rest/mailbox/mailbox/checkAlias{?value,appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'encryptionKey',
  ],
  version: 'v1',
  timeout: 10000,
  dataStrategy: DATASTRATEGY.NONE,
  storageStrategy: STORAGESTRATEGY.NONE,
};

const AliasEntity: IEntity<any> = {
  rel: 'mbx:createAlias',
  url: '/rest/mailbox/mailbox/{mbxId}/alias/{aliasId}{?appBrand}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'encryptionKey',
  ],
  version: 'v1',
  timeout: 10000,
  dataStrategy: DATASTRATEGY.NONE,
  storageStrategy: STORAGESTRATEGY.NONE,
};

export {
  MailboxEntity,
  CheckAliasEntity,
  AliasEntity,
  PasswordEntity,
  PasswordRecoveryEntity,
  PasswordRecoveryEmailEntity,
  PasswordRecoverySmsEntity,
  PasswordRecoveryActivateSmsEntity,
};
